import { isOpenAdminOrderStatusModal } from "@/atoms/order/is-open-admin-order-status-modal";
import { isOpenPartnerOrderStatusModal } from "@/atoms/order/is-open-partner-order-status-modal1";
import { Modal } from "flowbite-react";
import { useRecoilState } from "recoil";
import { AdminOrderStatusTable } from "../table/admin-order-status-table/AdminOrderStatusTable";
import { OrderStatusHeaderTable } from "../table/order-status-header-table/OrderStatusHeaderTable";
import { PartnerOrderStatusTable } from "../table/partner-order-status-table/PartnerOrderStatusTable";

export const OrderStatusModal = () => {
  const [partnerModal, setPartnerModal] = useRecoilState(
    isOpenPartnerOrderStatusModal
  );
  const [adminModal, setAdminModal] = useRecoilState(
    isOpenAdminOrderStatusModal
  );

  const closeModal = () => {
    if (partnerModal) {
      setPartnerModal(false);
    }

    if (adminModal) {
      setAdminModal(false);
    }
  };

  if (!partnerModal && !adminModal) {
    return null;
  }

  return (
    <Modal size="4xl" className="h-full" show={true} onClose={closeModal}>
      <Modal.Header>발주 진행 상태</Modal.Header>
      <Modal.Body className="px-[24px] pt-[24px]">
        <OrderStatusHeaderTable />
        <div className="w-full h-[20px]" />
        {partnerModal && <PartnerOrderStatusTable />}
        {adminModal && <AdminOrderStatusTable />}
      </Modal.Body>
    </Modal>
  );
};
